/* eslint-disable no-unused-vars */
import moment from 'moment'
import api from '@utils/api'
import { downloadFile } from '@utils/general'

import { StatusString } from '@constants/general';

export const getTotalUsers = (querys) => async (_dispatch, _getState) => {
  const response = await api.getTotalUsers(querys)
  return response
}

export const getUsersInternals = (querys) => async (_dispatch, _getState) => {
  const response = await api.getUsers(querys)
  return response
}

export const changeStatusUser = ({ correo, estatus, justification }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (estatus === StatusString.STATUS_ACTIVE) validateStatus = 'suspend'
  if (estatus === StatusString.STATUS_SUSPENDED) validateStatus = 'activate'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.changeStatusUser(correo, data)
  return response;
}

// export const reactiveUser = ({email, justification}) => async (_dispatch, _getState) => {
//   const body = {
//     status: 'activate',
//     reason: justification
//   }
//   const response = await api.changeStatusUser(email, body)
//   return response
// }

// export const suspendUser = ({email, justification}) => async (_dispatch, _getState) => {
//   const body = {
//     status: 'suspend',
//     reason: justification
//   }
//   const response = await api.changeStatusUser(email, body)
//   return response
// }

export const getTotalBulkLoad = (querys) => async (_dispatch, _getState) => {
  const response = await api.getTotalBulkLoad(querys)
  return response
}

export const getListInternalUserLoads = (querys) => async (_dispatch, _getState) => {
  const response = await api.getListInternalUserLoads(querys)

  return response
}

export const getDetailLoadInternal = ({ id, archivo }) => async (_dispatch, _getState) => {
  const response = await api.getDetailLoadInternal(id)
  if (!response?.status) {
    downloadFile(response.data, archivo)
  }
  return response
}

export const getDetailUpload = ({ id }) => async (_dispatch, _getState) => {
  const response = await api.getDetailUpload(id)

  return response
}

export const preloadInternalUsers = ({ countryId, companyId, file }) => async (_dispatch, _getState) => {
  const formData = new FormData()
  const data = {
    id_pais: countryId,
    id_empresa: companyId,
  }
  formData.append('files', file[0].file)
  formData.append('content', JSON.stringify(data))

  const response = await api.preloadInternalUsers(formData)
  return response
}

export const rejectUpload = ({ id, justification }) => async (_dispatch, _getState) => {
  const data = {
    reason: justification,
    status: 'reject'
  }
  const response = await api.rejectUpload(id, data)
  return response
}
export const executeUpload = ({ id, justification }) => async (_dispatch, _getState) => {
  const data = {
    reason: justification,
    status: 'execute'
  }
  const response = await api.executeUpload(id, data)
  return response
}

export const getReportTotalInternalByCountry = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalInternalByCountry()
  return response
}

export const reportTotalInternalByCountry = () => async (_dispatch, _getState) => {
  const response = await api.reportTotalInternalByCountry()
  if (!response?.status) {
    downloadFile(response.data, `amx_total_usuarios_internos_pais_${moment().locale('es').format('DDMMYYYYHHmmss')}.xlsx`)
  }
  return response
}

export const reportDetailInternal = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailInternal()
  if (!response?.status) {
    downloadFile(response.data, `amx_detalle_usuarios_internos_${moment().locale('es').format('DDMMYYYYHHmmss')}.csv`)
  }
  return response
}

export const getReportTotalSupplierByCountry = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalSupplierByCountry()
  return response
}

export const getReportUnassociatedMSDetail = () => async (_dispatch, _getState) => {
  const response = await api.getReportUnassociatedMSDetail()
  return response
}

export const reportUnassociatedMSDetail = () => async (_dispatch, _getState) => {
  const response = await api.reportUnassociatedMSDetail()
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}

export const reportTotalSupplierByCountry = () => async (_dispatch, _getState) => {
  const response = await api.reportTotalSupplierByCountry()
  if (!response?.status) {
    downloadFile(response.data, `amx_total_usuarios_provedores_pais_${moment().locale('es').format('DDMMYYYYHHmmss')}.xlsx`)
  }
  return response
}
export const reportDetailSupplier = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailSupplier()
  if (!response?.status) {
    downloadFile(response.data, `amx_detalle_usuarios_provedores_${moment().locale('es').format('DDMMYYYYHmmss')}.xlsx`)
  }
  return response
}

export const getReportTotalFoliosPRGEH = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalFoliosPRGEH()
  return response
}
export const getReportTotalFoliosPDD = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalFoliosPDD()
  return response
}
export const getReportTotalFoliosPCI = (querys) => async (_dispatch, _getState) => {
  const response = await api.getReportTotalFoliosPCI(querys)
  return response
}
export const getReportTotalFoliosPDDC = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalFoliosPDDC()
  return response
}
export const reportTotalPRGEH = () => async (_dispatch, _getState) => {
  const response = await api.reportTotalPRGEH()
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}
export const reportDetailPRGEH = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailPRGEH()
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}

export const reportDetailPDD = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailPDD()
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}

export const reportDetailPCI = (querys) => async (_dispatch, _getState) => {
  const response = await api.reportDetailPCI(querys)
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}

export const reportDetailPDDC = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailPDDC()
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}

export const getReportTotalFoliosPC = () => async (_dispatch, _getState) => {
  const response = await api.getReportTotalFoliosPC()
  return response
}

export const reportDetailPC = () => async (_dispatch, _getState) => {
  const response = await api.reportDetailPC()  
  if (!response?.status) {
    downloadFile(response.file, response.fileName)
  }
  return response
}
